export default function Alert(theme) {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          alignItems: 'center',
          borderRadius: 0,

          '& .MuiAlert-icon': {
            marginRight: '15px',
          },
        },
        filled: {
          borderLeftWidth: '5px',
          padding: '10px 15px',
        },
        filledWarning: {
          border: `1px solid ${theme.palette.warning.main}`,
          backgroundColor: theme.palette.warning.lighter,
          borderLeftWidth: '5px',
          '& .MuiAlert-icon svg': {
            color: theme.palette.warning.dark,
          },
        },
        filledError: {
          border: `1px solid ${theme.palette.error.main}`,
          backgroundColor: theme.palette.error.lighter,
          borderLeftWidth: '5px',
          '& .MuiAlert-icon svg': {
            color: theme.palette.error.dark,
          },
          color: 'black',
        },
        filledSuccess: {
          border: `1px solid ${theme.palette.success.main}`,
          backgroundColor: theme.palette.success.lighter,
          borderLeftWidth: '5px',
          '& .MuiAlert-icon svg': {
            color: theme.palette.success.dark,
          },
          color: 'black',
        },
      },
    },
  };
}
